import { connect } from 'react-redux';
import { fieldEditUpdate, getScreenData } from 'cw-ui-core';
import TextBoxList from './TextBoxList';

const mapStateToProps = (state, props) => {
    return {
        items: getScreenData(state.screen, props.path, props.screenKey),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        itemAdded: items => {
            items.push('');

            dispatch(fieldEditUpdate(props.path, items, props.screenKey));

            if (props.onChange != null) {
                props.onChange(items.length - 1, '', 'add');
                props.onFocusChange(null);
            }
        },
        itemChanged: (items, index, text) => {
            const changedItems = items;
            changedItems[index] = text;

            dispatch(fieldEditUpdate(props.path, changedItems, props.screenKey));

            if (props.onChange != null) {
                props.onChange(index, text, 'change');
            }
        },
        itemDeleted: (items, index) => {
            const deletedItem = items.splice(index, 1);

            dispatch(fieldEditUpdate(props.path, items, props.screenKey));

            if (props.onChange != null) {
                props.onChange(-1, deletedItem[0], 'delete');
            }
        },
        focusChange: index => {
            if (props.onFocusChange != null) {
                props.onFocusChange(index);
            }
        },
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...stateProps,
        ...ownProps,
        focusChange: dispatchProps.focusChange,
        itemAdded: () => {
            dispatchProps.itemAdded(stateProps.items ? stateProps.items.toArray() : []);
        },
        itemChanged: (index, text) => {
            dispatchProps.itemChanged(stateProps.items ? stateProps.items.toArray() : [], index, text);
        },
        itemDeleted: index => {
            dispatchProps.itemDeleted(stateProps.items ? stateProps.items.toArray() : [], index);
        },
    };
};

const TextBoxListContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(TextBoxList);

export default TextBoxListContainer;
